export class ClientItemDto
{
    nomClient: String;
}